import Clarity from '@microsoft/clarity';
import { LoginIdentityUser } from '@streem/auth';
import config from '../config';

export function initializeClarity(): void {
    if (!config.clarityEnabled) return;
    console.log('[clarity] Initializing...');
    Clarity.init(config.clarityProjectId);
}

export function addUserToClaritySession({ id }: LoginIdentityUser): void {
    if (!config.clarityEnabled) return;
    Clarity.identify(id, undefined, undefined, id);
    console.log(`[clarity] setting custom user ID to ${id}`);
}

export function addRegionCodeToClaritySession(regionCode: string): void {
    if (!config.clarityEnabled) return;
    Clarity.setTag('region_code', regionCode);
}

export function addCompanyCodeToClaritySession(companyCode: string): void {
    if (!config.clarityEnabled) return;
    Clarity.setTag('company_code', companyCode);
}

export function addRoomIdToClaritySession(roomId: string): void {
    if (!config.clarityEnabled) return;
    Clarity.setTag('room_id', roomId);
}

export function addReservationIdtoClaritySession(roomId: string): void {
    if (!config.clarityEnabled) return;
    Clarity.setTag('reservation_id', roomId);
}

export function addCallSourceToClarity(callSource: string): void {
    if (!config.clarityEnabled) return;
    Clarity.setTag('call_source', callSource);
}

export function upgradeClaritySession(): void {
    if (!config.clarityEnabled) return;
    Clarity.upgrade('reservation_received');
}
